module.exports = __webpack_public_path__ + "static/media/myimage.8f46dd42.jpg";